import React, {useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import {Form} from 'react-bootstrap';
import Select from 'react-select';
import {toast} from 'react-toastify';
import {Button} from 'react-bootstrap';
export default function StepCondition(props) {
  const [data, setData] = useState({
    year: new Date().getFullYear().toString(),
    companyid: null,
    costid: null,
    yearMonth: null
  });
  //   useEffect(() => {
  //     if (props.places) {
  //       setAllow(props.item.agreeExpend);
  //     }
  //   }, [props.places]);

  return (
    <div className="row">
      <Select
        className="col-12 col-md-3 mb-2"
        value={props.dropdownCompany.DATA.filter(
          (e) => e.value === data.companyid
        )}
        placeholder={'เลือกบริษัท'}
        options={props.dropdownCompany.DATA}
        onChange={(v) => {
          setData((prevState) => ({
            ...prevState,
            companyid: v.value
          }));
          props.setCompanyIdSelect(v.value);
        }}
      />
      <Select
        className="col-12 col-md-3 mb-2"
        value={props.dropdownCostcenter.DATA.filter(
          (e) => e.value === data.costid
        )}
        placeholder={'เลือกกลุ่มต้นทุน'}
        options={
          data.companyid === ''
            ? props.dropdownCostcenter.DATA
            : props.dropdownCostcenter.DATA.filter(
                (e) => e.company === data.companyid
              )
        }
        onChange={(v) => {
          setData((prevState) => ({
            ...prevState,
            costid: v.value
          }));
          props.setCostIdSelect(v.value);
        }}
      />
      <Button
        className="col-12 col-md-1 mb-2"
        variant="success"
        onClick={() => {
          if (
            data.companyid === null ||
            data.costid === null ||
            data.year === null
          ) {
            toast.error('บริษัท/กลุ่มต้นทุนให้ครบ');
          } else {
            props.downloadCostCenterWs2(
              'year',
              data.companyid,
              data.costid,
              data.year
            );
          }
        }}
      >
        ค้นหา
      </Button>
      <div className="col-6">
        <Card>
          <Card.Header>งบคงเหลือรายเดือน</Card.Header>
          <Card.Body>
            <div className="col-12">
              {props.data3
                .filter((ele) => !ele.select)
                .filter(
                  (el) =>
                    // Number(el.costRemain.replace(/,/g, '')) >= 100 &&
                    // el.month <
                    //   new Date().toISOString().split('T')[0].substring(0, 7)
                    Number(el.costRemain.replace(/,/g, '')) >= 100
                )
                .map((e) => (
                  <div className="input-group col-12 m-2">
                    <div className="input-group-prepend">
                      <div className="input-group-text" style={{width: 130}}>
                        {e.month}
                      </div>
                    </div>
                    <input
                      style={{
                        textAlign: 'right',
                        backgroundColor: 'white'
                      }}
                      disabled
                      type="text"
                      className="form-control"
                      value={e.costRemain}
                    />
                    <input
                      type="button"
                      className="form-control btn-primary"
                      value={'เลือก'}
                      onClick={(el) => {
                        props.updateData3(e.month, true);
                      }}
                    />
                  </div>
                ))}
            </div>
          </Card.Body>
        </Card>
      </div>
      <div className="col-6">
        <Card>
          <Card.Header>งบที่ถูกเลือก</Card.Header>
          <Card.Body>
            <div className="col-12">
              {props.data3
                .filter((ele) => ele.select)
                .map((e) => (
                  <div className="input-group col-12 m-2">
                    <div className="input-group-prepend">
                      <div className="input-group-text" style={{width: 130}}>
                        {e.month}
                      </div>
                    </div>
                    <input
                      style={{
                        textAlign: 'right',
                        backgroundColor: 'white'
                      }}
                      disabled
                      type="text"
                      className="form-control"
                      value={e.costRemain}
                    />
                    <input
                      type="button"
                      className="form-control btn-secondary"
                      value={'เอาออก'}
                      onClick={(el) => {
                        props.updateData3(e.month, false);
                      }}
                    />
                  </div>
                ))}
            </div>
          </Card.Body>
        </Card>
      </div>
      <div className="row col-12">
        <Select
          className="col-12 col-md-6"
          value={props.data3
            .map((el) => ({...el, label: el.month, value: el.month}))
            .filter((e) => e.value === data.yearMonth)}
          placeholder={'เลือกเดือนปลายทางที่รับงบ'}
          options={props.data3
            .filter(
              (e) =>
                e.month >=
                new Date().toISOString().split('T')[0].substring(0, 7)
            )
            .map((el) => ({...el, label: el.month, value: el.month}))}
          onChange={(v) => {
            setData((prevState) => ({
              ...prevState,
              yearMonth: v.value
            }));
            props.setYearMonthSelect(v.value.replaceAll('-', ''));
          }}
        />
        <div className="input-group col-12 col-md-6">
          <div className="input-group-prepend">
            <div className="input-group-text" style={{width: 130}}>
              {'รวม'}
            </div>
          </div>
          <input
            style={{
              textAlign: 'right',
              backgroundColor: 'white'
            }}
            disabled
            type="text"
            className="form-control"
            value={props.data3
              .filter((e) => e.select)
              .reduce(
                (prev, curr) =>
                  prev + Number(curr.costRemain.replace(/,/g, '')),
                0
              )}
          />
        </div>
      </div>
    </div>
  );
}
